import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import MUIDataTable from 'mui-datatables';
import Spinner from '../../components/Spinner';
import './index.css';
import AdminModal from '../../components/Modal';
import ChequeDataComponent from '../../components/chequeDataComponent';
import { GET_ALL_BANKS } from '../../Graphql/Queries';
import { formatAmount } from '../../utils';
import { ErrorNotification } from '../../components/Notification';

const ExpandableTable = ({
  rowData,
  game_id,
  raiseAlert,
  setSelectedWinners,
  setMaxSelectedWinners,
  setInitiatePayment,
  state,
  handleChange,
  setPaymentType,
  paymentType,
  showDetailModal,
  setShowMDetailModal,
  handleclose2,
  setTotalWinnersSelected,
}) => {
  let loading = false;

  const [open, setOpen] = useState(true);

  // const [totalWinnersSelected,setTotalWinnersSelected]=useState(false)

  // console.log('rowdata', rowData)

  const [banks, setBanks] = useState([]);
  const [selectedItem, setSelectedItem] = useState();

  useQuery(GET_ALL_BANKS, {
    onCompleted: (data) => {
      setBanks(data.bank);
    },
    onError: () => {
      ErrorNotification('Failed to load banks');
    },
  });

  const options = {
    filterType: 'checkbox',
    filter: false,
    print: false,
    onRowSelectionChange: (v) => {
      setOpen(!open);

      let rowWinners = [];
      let maxWinners = [];
      v.map((r) => {
        if (rowData[r].total_winning_amount.amount > 5000) {
          let c = {
            customer_id: rowData[r].customer_id,
            game_id: game_id,
          };
          setPaymentType('cheque');
          setSelectedItem(rowData[r]);
          setInitiatePayment(true);

          maxWinners.push(c);
        } else {
          let c = {
            customer_id: rowData[r].customer_id,
            game_id: game_id,
          };

          setInitiatePayment(true);
          rowWinners.push(c);
        }
      });

      if (rowWinners.length == rowData.length) {
        setTotalWinnersSelected(true);
      } else {
        setTotalWinnersSelected(false);
      }

      setSelectedWinners(rowWinners);
      setMaxSelectedWinners(maxWinners);
    },
    customToolbarSelect: () => {},
    sortOrder: {
      name: 'created_at',
      direction: 'desc',
    },
  };

  const columns = [
    {
      name: 'id',
      label: 'Game Id',
      options: {
        filter: true,
        sort: true,
        display: false,
        customBodyRender: (val) => {
          return (
            <p style={{ position: 'relative', left: 5, top: 10 }}>{val}</p>
          );
        },
      },
    },
    {
      name: 'customer',
      label: 'Full Name',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (val) => {
          return (
            <p style={{ position: 'relative', left: 5, top: 10 }}>
              {val.full_name}
            </p>
          );
        },
      },
    },
    {
      name: 'customer',
      label: 'Phone Number',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (val) => {
          return (
            <p style={{ position: 'relative', left: 30, top: 10 }}>
              {val.phone_number}
            </p>
          );
        },
      },
    },
    {
      name: 'total_winning_amount',
      label: 'Winning Amount(GHS)',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (val) => {
          return (
            <p style={{ position: 'relative', left: 50, top: 10 }}>
              {formatAmount(val)}
            </p>
          );
        },
      },
    },

    {
      name: 'total_stake_amount',
      label: 'Staked amount(GHS)',
      options: {
        filter: true,
        sort: false,
        customBodyRender: (val) => {
          return (
            <p style={{ position: 'relative', left: 50 }}>
              {formatAmount(val)}
            </p>
          );
        },
      },
    },

    // {
    //   name: "payment_status",
    //   label: "Payment status",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (val) => {
    //       return (
    //         <div>
    //           {val === "paid" ? (
    //             <div className="divheight bg-greenLight" style={{ position: "relative", left: 50 }} >
    //               <p className="text-green">{val}</p>
    //             </div>
    //           ) : (
    //             <div className="divheight bg-orangeLight" style={{ position: "relative", left: 50 }} >
    //               <p style={{ fontSize: 10, color: "#FF0000", position: "relative", top: 2 }} >{"pending"}</p>
    //             </div>
    //           )}
    //         </div>
    //       );
    //     },
    //   },
    // },
  ];

  return (
    <div style={{ padding: 20, position: 'relative' }}>
      <AdminModal
        show={showDetailModal}
        close={!showDetailModal}
        title={'Pay with cheque'}
        body={
          <ChequeDataComponent
            banks={banks}
            state={state}
            handleChange={handleChange}
            selectedItem={selectedItem}
            raiseAlert={raiseAlert}
          />
        }
        handleClose={handleclose2}
      />

      {loading ? (
        <div
          style={{
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spinner />
        </div>
      ) : (
        <MUIDataTable
          data={rowData ? rowData : []}
          title="Game Winners"
          columns={columns}
          options={options}
          // onRowClick={handleRowClick}
        />
      )}
      <div style={{ display: 'flex', flexDirection: 'row', float: 'right' }}>
        <div style={{ position: 'relative', top: 10, marginRight: 20 }}>
          <button
            disabled={paymentType === 'cheque'}
            className="btn btn-success"
            onClick={() => raiseAlert()}
          >
            Pay with Momo
          </button>
        </div>

        <div style={{ position: 'relative', top: 10 }}>
          <button
            disabled={paymentType === 'momo'}
            className="btn btn-warning"
            onClick={() => {
              setShowMDetailModal(true);
              setInitiatePayment(true);
            }}
          >
            Pay with Cheque
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpandableTable;
